import { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { CompatRoute } from "react-router-dom-v5-compat";

import useEffectOnMount from "seneca-common/utils/hooks/useEffectOnMount";

import lazyWithPreload from "features/app/components/lazyWithPreload";
import RedirectToAppropriateHomepage from "features/common/routing/RedirectToAppropriateHomePage";
import { ROUTES } from "routing/routes";

import { linkToClassroomCourse } from "./course/links";
import CourseRoute from "./course/Route";

const QuizSessionRoute = lazyWithPreload(
  () =>
    import(
      /* webpackChunkName: "quiz-session-route-chunk" */
      "./quiz-session/Route"
    )
);

const EnglishDemoRoute = lazyWithPreload(
  () =>
    import(
      /* webpackChunkName: "english-demo-route-chunk" */
      "./english-demo/Route"
    )
);

export default function ClassroomSubRouter() {
  useEffectOnMount(() => {
    QuizSessionRoute.preload();
  });

  return (
    <Switch>
      <Route path={linkToClassroomCourse()}>
        <CourseRoute />
      </Route>
      <CompatRoute
        path={ROUTES.CLASSROOM.QUIZ_SESSION.path}
        render={() => (
          <Suspense>
            <QuizSessionRoute />
          </Suspense>
        )}
      />
      <CompatRoute
        path={ROUTES.CLASSROOM.ENGLISH_DEMO.path}
        render={() => (
          <Suspense>
            <EnglishDemoRoute />
          </Suspense>
        )}
      />
      <RedirectToAppropriateHomepage />
    </Switch>
  );
}
